import {
  blue100,
  gradient_brandGradientEnd,
  gradient_brandGradientStart,
  grey500,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { fontFormLabel } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.EnableVirtualCardSuccessCTA {
    position: relative;
    background: ${blue100};
    border-radius: 12px;
    padding: ${spacing(5)};
    margin-bottom: ${spacing(4)};

    /* Gradient border */
    /* 
      NOTE: This is used twice in the codebase as of this writing
      We can make a box variant that accounts for this background and
      standardize it if it comes back
    */
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      padding: 2px;
      border-radius: 12px;
      background: linear-gradient(
        180deg,
        ${gradient_brandGradientStart} 0%,
        ${gradient_brandGradientEnd} 100%
      );
      -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      pointer-events: none;
    }

    .close-button {
      position: absolute;
      top: ${spacing(3)};
      right: ${spacing(3)};
      background: none;
      border: none;
      cursor: pointer;
      padding: ${spacing(1)};
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${grey500};

      &:hover {
        opacity: 0.7;
      }
    }

    .create-text {
      ${fontFormLabel}
    }
    .cta-button {
      padding: ${spacing(2)} ${spacing(4)};
    }
  }
`
